import React from 'react';

const gradGoldCoral = (id) => (
  <defs>
    <linearGradient id={id} x1="4" y1="4" x2="44" y2="44" gradientUnits="userSpaceOnUse">
      <stop stopColor="#FEB139" />
      <stop offset="0.55" stopColor="#FD7651" />
      <stop offset="1" stopColor="#EA6820" />
    </linearGradient>
    <linearGradient id={`${id}-soft`} x1="8" y1="8" x2="40" y2="40" gradientUnits="userSpaceOnUse">
      <stop stopColor="#FEB139" stopOpacity="0.35" />
      <stop offset="1" stopColor="#FD7651" stopOpacity="0.5" />
    </linearGradient>
  </defs>
);

function SvgFrame({ gid, className, children }) {
  return (
    <svg
      className={className}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      {gradGoldCoral(gid)}
      {children}
    </svg>
  );
}

export function PopularCategoryIcon({ variant, className = '' }) {
  const g = `pgn-popcat-${variant}`;

  switch (variant) {
    case 'showAll':
      return (
        <SvgFrame gid={g} className={className}>
          <rect
            x="10"
            y="10"
            width="12"
            height="12"
            rx="3"
            stroke={`url(#${g})`}
            strokeWidth="2"
            fill={`url(#${g}-soft)`}
          />
          <rect
            x="26"
            y="10"
            width="12"
            height="12"
            rx="3"
            stroke={`url(#${g})`}
            strokeWidth="2"
            fill={`url(#${g}-soft)`}
          />
          <rect
            x="10"
            y="26"
            width="12"
            height="12"
            rx="3"
            stroke={`url(#${g})`}
            strokeWidth="2"
            fill={`url(#${g}-soft)`}
          />
          <rect
            x="26"
            y="26"
            width="12"
            height="12"
            rx="3"
            stroke={`url(#${g})`}
            strokeWidth="2"
            fill={`url(#${g}-soft)`}
          />
        </SvgFrame>
      );
    case 'sport':
      return (
        <SvgFrame gid={g} className={className}>
          {/* Hantel — sport / fitness */}
          <line
            x1="11"
            y1="17"
            x2="11"
            y2="31"
            stroke={`url(#${g})`}
            strokeWidth="9"
            strokeLinecap="round"
          />
          <line
            x1="37"
            y1="17"
            x2="37"
            y2="31"
            stroke={`url(#${g})`}
            strokeWidth="9"
            strokeLinecap="round"
          />
          <line
            x1="11"
            y1="24"
            x2="37"
            y2="24"
            stroke={`url(#${g})`}
            strokeWidth="3.4"
            strokeLinecap="round"
          />
        </SvgFrame>
      );
    case 'party':
      return (
        <SvgFrame gid={g} className={className}>
          <path
            d="M14 40V22l10-8 10 8v18Z"
            stroke={`url(#${g})`}
            strokeWidth="2.1"
            strokeLinejoin="round"
            fill={`url(#${g}-soft)`}
          />
          <path d="M20 18l4-8 4 8" stroke="#c084fc" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="18" cy="12" r="2" fill={`url(#${g})`} />
          <circle cx="30" cy="10" r="1.8" fill="#FEB139" />
          <circle cx="34" cy="16" r="1.5" fill="#FD7651" />
        </SvgFrame>
      );
    case 'gaming':
      return (
        <SvgFrame gid={g} className={className}>
          <rect
            x="7"
            y="15"
            width="34"
            height="22"
            rx="7"
            stroke={`url(#${g})`}
            strokeWidth="2.1"
            fill={`url(#${g}-soft)`}
          />
          <path
            d="M15 24v-4M13 22h4"
            stroke="#6366f1"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
          <circle cx="28" cy="22" r="2.2" fill={`url(#${g})`} />
          <circle cx="35" cy="22" r="2.2" fill={`url(#${g})`} />
          <path
            d="M24 11v4"
            stroke={`url(#${g})`}
            strokeWidth="2"
            strokeLinecap="round"
            opacity="0.75"
          />
        </SvgFrame>
      );
    case 'hangout':
      return (
        <SvgFrame gid={g} className={className}>
          <path
            d="M12 22h20v12a8 8 0 01-8 8H20a8 8 0 01-8-8V22z"
            stroke={`url(#${g})`}
            strokeWidth="2.1"
            strokeLinejoin="round"
            fill={`url(#${g}-soft)`}
          />
          <path
            d="M32 26h4a3.5 3.5 0 010 7h-4"
            stroke={`url(#${g})`}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M18 12s1.5-3 4-3 4 3 4 3M20 8s2-2 4-2"
            stroke={`url(#${g})`}
            strokeWidth="2"
            strokeLinecap="round"
            opacity="0.85"
          />
        </SvgFrame>
      );
    case 'trip':
      return (
        <SvgFrame gid={g} className={className}>
          <rect
            x="5"
            y="30"
            width="38"
            height="9"
            rx="2.5"
            stroke={`url(#${g})`}
            strokeWidth="2"
            fill={`url(#${g}-soft)`}
          />
          <path
            d="M11 30L16 17h16l5 13"
            fill="rgba(254, 177, 57, 0.14)"
            stroke={`url(#${g})`}
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <circle cx="14" cy="34.5" r="3.2" fill="#fafaf9" stroke={`url(#${g})`} strokeWidth="1.8" />
          <circle cx="34" cy="34.5" r="3.2" fill="#fafaf9" stroke={`url(#${g})`} strokeWidth="1.8" />
          <path d="M16 24h16" stroke={`url(#${g})`} strokeWidth="1.8" strokeLinecap="round" opacity="0.45" />
        </SvgFrame>
      );
    case 'other':
      return (
        <SvgFrame gid={g} className={className}>
          <path
            d="M24 5v10M24 33v10M5 24h10M33 24h10M10 10l6 6M32 32l6 6M38 10l-6 6M10 38l6-6"
            stroke={`url(#${g})`}
            strokeWidth="2.2"
            strokeLinecap="round"
          />
          <circle cx="24" cy="24" r="4" fill={`url(#${g})`} opacity="0.9" />
        </SvgFrame>
      );
    case 'create':
      return (
        <SvgFrame gid={g} className={className}>
          <circle cx="24" cy="24" r="17" fill={`url(#${g}-soft)`} stroke={`url(#${g})`} strokeWidth="2" />
          <path d="M24 15v18M15 24h18" stroke={`url(#${g})`} strokeWidth="2.8" strokeLinecap="round" />
        </SvgFrame>
      );
    default:
      return null;
  }
}
